import { useQuery } from 'sith-frontend-utils'
import { RecommendationQuery, RecommendationQueryName } from './reco.query'

export const useRecommendation = (contentfulId: string) => {
  const { data } = useQuery<RecommendationQuery>(RecommendationQueryName, { id: contentfulId })
  const recoData = data?.data.recommendationCollection.items?.[0]
  return recoData
}
